import React from 'react';
import { SpinnerCircular } from 'spinners-react';

const LoadingSpinner: React.FunctionComponent = () => {
    return <SpinnerCircular speed={150} secondaryColor="rgba(0,0,0,0.20)" color="#034e92" />;
}

export default LoadingSpinner;
